import { useParams } from "react-router-dom";
import BookingIntegrationShell from "@/components/integrations/BookingIntegrationShell";
import NoIndex from "@/components/NoIndex";

export default function HostedBooking() {
  const { businessSlug } = useParams();
  return <><NoIndex /><BookingIntegrationShell identifier={businessSlug} /></>;
}
